module.exports = __webpack_public_path__ + "img/universal_delete.a64f3c7a.svg";